<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Usuários"
          newText="Novo Usuário"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableActive="false"
          :enableView="true"
          :enableReset="true"
          :enableSenhaPath="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "usersTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "photo",
        "name",
        "login",
        "access_nivel",
        "email",
        "setores_vinculados",
        "actions",
      ],
      tableData: [
        "id",
        "photo",
        "name",
        "login",
        "access_nivel",
        "email",
        "setores_vinculados",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "name",
          "login",
          "access_nivel",
          "email",
          "setores_vinculados",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          name: "Login",
          name: "Nome",
          access_nivel: "Nível de Acesso",
          email: "E-mail",
          setores_vinculados: "Setores Vinculados",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          access_nivel: [
            {
              id: 1,
              text: "Chamador",
            },
            {
              id: 2,
              text: "Chamador + Mover senhas",
            },
            {
              id: 3,
              text: "Chamador + Relatórios",
            },
            {
              id: 4,
              text: "Chamador + Relatórios + Fechar dia",
            },
            {
              id: 5,
              text: "Gerenciar unidade",
            },
            {
              id: 6,
              text: "Usuário da segurança",
            },
            {
              id: 7,
              text: "Administrador do sistema",
            },
          ],
        },
        templates: {
          access_nivel: function (h, row, index) {
            let access = [
              "Chamador",
              "Chamador + Mover senhas",
              "Chamador + Relatórios",
              "Chamador + Relatórios + Fechar dia",
              "Gerenciar unidade",
              "Usuário da segurança",
              "Administrador do sistema",
            ];

            return access[row.access_nivel - 1];
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["setores"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "users/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    importFile() {
      const self = this;
      let api = self.$store.state.api + "import-users";

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.showMessageImport = true;
          self.$refs.usersCrud.$refs.table.refresh();
        })
        .catch((error) => {
          self.$message(
            "Ops",
            "Houve um erro durante a importação da planilha, verifique a planilha e tente novamente.",
            "error"
          );
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        photo: "photo",
        name: "name",
        login: "login",
        access_nivel: "access_nivel",
        email: "email",
        setores_vinculados: "setores_vinculados",
      };
      let filters = "user_system=0&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    openInput() {
      document.getElementById("fileImport").click();
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>